export const userSuggestionsTableConfig = () => {
    return [
        {
            id: "name",
            header: "Пользователь",
            field: "name",
        },
        {
            id: "phone",
            header: "Номер телефона",
            field: "phone",
            sortBy: "basic",
        },
        {
            id: "email",
            header: "E-mail",
            field: "email",
        },
        {
            id: "suggestion",
            header: "Предложение",
            field: "suggestion",
        },
        {
            id: "address",
            header: "Адрес",
            field: "address",
        },
        {
            id: "date",
            header: "Дата и время",
            field: "date",
        },
        {
            id: "path",
            header: "Путь",
            field: "path",
        },
        {
            id: "status",
            header: "Статус",
            field: "Статус",
        },
    ];
}
